import { useState, useEffect } from "react";

export default function useSelectionTooltip(editorRef) {
  const [tooltipPos, setTooltipPos] = useState({
    top: 0,
    left: 0,
    visible: false,
  });
  const [selectionFontSize, setSelectionFontSize] = useState("");

  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;

    const updateSelection = () => {
      const selection = window.getSelection();
      if (!selection.rangeCount) {
        setTooltipPos((p) => ({ ...p, visible: false }));
        return;
      }

      const range = selection.getRangeAt(0);
      if (range.collapsed) {
        setTooltipPos((p) => ({ ...p, visible: false }));
        return;
      }

      let el = selection.focusNode;
      if (el?.nodeType === Node.TEXT_NODE) el = el.parentElement;
      if (!el) return;

      const size = window.getComputedStyle(el).fontSize;
      setSelectionFontSize(size);

      const rect = range.getBoundingClientRect();
      setTooltipPos({
        top: rect.top - 30 + window.scrollY,
        left: rect.left + window.scrollX,
        visible: true,
      });
    };

    editor.addEventListener("mouseup", updateSelection);
    editor.addEventListener("keyup", updateSelection);

    return () => {
      editor.removeEventListener("mouseup", updateSelection);
      editor.removeEventListener("keyup", updateSelection);
    };
  }, [editorRef]);

  return { tooltipPos, selectionFontSize };
}